'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {AvatarColors} from '../../../core-utilities/domain/AvatarColors';
import {getCollection} from '../../../core-utilities/domain/ReduxUtils';
import {abbreviate} from '../../../core-utilities/filters/filterUtils';
import {I18nMessage} from '../../../components/I18nMessage';
import {ListItem} from '../../../components/lists/ListItem';
import {ORGANIZATION_COLLECTION} from '../../../organizations/domain/config';
import {PERSONNEL_COLLECTION} from '../../domain/PersonDomain';
import {AvatarImage} from '../../../files/components/AvatarImage';
import {TEAMS_COLLECTION} from '../../domain/TeamDomain';


export function PeopleItemView(props) {
  const model = props.model || {};
  const collection = getCollection(model);
  const role = collection === PERSONNEL_COLLECTION && model.role ? model.role : null;
  return (
    <ListItem
      className={classNames("PeopleItem", props.className, {
        PeopleItem_hasRole: role,
        PeopleItem_isSelected: props.isSelected,
      })}
      bindParam={props.model}
      title={model.name ? model.name : void 0}
      onClick={props.onClick}
      onContextMenu={props.onContextMenu}
    >
      <div className="PeopleItem__avatar">
        <div className="PeopleItem__dotContainer">
          <AvatarImage
            iconClass={classNames("Avatar__largeIcon", props.presenceClass)}
            avatarInitials={getInitials(collection, model.name)}
            avatarColor={AvatarColors.getColor(model.avc)}
            avatarFontColor={AvatarColors.getFontColor(model.avc)}
            url={model.avatar ? model.avatar.url : null}
            displayWidth={44}
            displayHeight={44}
            targetWidth={44}
            targetHeight={44}
          />
          {props.isUser ? (
            <div
              className={classNames('PeopleItem__dot', {
                'PeopleItem__dot_active': props.isOnline,
                'PeopleItem__dot_inactive': props.isInactive,
                'PeopleItem__dot_pulse': props.pulseOnline,
              })}
            />
          ) : null}
        </div>
      </div>
      <h2>
        {model.name ? model.name : (props.nullLabel ? <I18nMessage message={props.nullLabel} /> : null)}
      </h2>
      {role ? (
        <p>
          {role}
        </p>
      ) : null}
      {!props.isSelected ? null : (
        <i className="PeopleItem__check" />
      )}
    </ListItem>
  );
}

export function getInitials(collection, name) {
  if (!name) {
    return '-';
  } else {
    switch (collection) {
      case ORGANIZATION_COLLECTION:
      case TEAMS_COLLECTION:
        return name.charAt(0).toUpperCase();
      case PERSONNEL_COLLECTION:
        return abbreviate(name);
    }
  }
}

PeopleItemView.propTypes = {
  className: T.string,
  isUser: T.bool,
  isOnline: T.bool,
  isInactive: T.bool,
  pulseOnline: T.bool,
  isSelected: T.bool,
  nullLabel: T.string,
  model: T.object,
  onClick: T.func,
  onContextMenu: T.func,
};

PeopleItemView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/personnel/components/PeopleItem/PeopleItemView.js